<template lang="pug">
.container-filtro
  .filtro
    .filtro__item 
      .mb-1.weight-300 {{ label }}
      el-radio-group(v-model="radio" :size="size" @change="update" )
        el-radio-button(v-for="item in lista" :label="item.nome || item" :key="item.nome || item" border :disabled="item.disabled")
    
    .filtro__busca(:class="{ 'filtro__busca__focused': isFocused}" class='pointer')
      el-input(
        ref="filtroBusca"
        :placeholder="isFocused ? placeholder : ''"
        prefix-icon="el-icon-search"
        v-model="input"
        @click.native="setFocus"
        @focus="isFocused = true"
        @blur="!input && (isFocused = false)"
        @input="$emit('inputValue', $event)"
      )
</template>

<script>
export default {
  props: {
    lista: {
      type: Array,
      required: true
    },
    selecionado: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Buscar...'
    },
    label: {
      type: String,
      default: 'Filtrar por:'
    },
    size: {
      type: String,
      default: 'mini'
    }
  },

  data() {
    return {
      radio: '',
      input: '',
      isFocused: false
    }
  },

  created() {
    this.radio = this.selecionado
  },

  watch: {
    selecionado() {
      this.radio = this.selecionado
    }
  },

  methods: {
    update(e) {
      this.$emit('update', e)
    },

    setFocus() {
      this.$refs.filtroBusca.focus()
    }
  }
}
</script>

<style lang="scss">
.container-filtro {
  width: 100%;
  margin: 35px 0;
  .el-input__icon {
    font-weight: bold;
  }

  .filtro {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .filtro__item {
      color: #fff;
      font-size: 13px;
      font-weight: 500;
      display: flex;
      flex-direction: column;

      .el-radio-group {
        .el-radio-button {
          .el-radio-button__inner {
            background: transparent;
            color: #8e8f92;

            &:hover {
              color: #2b80c2;
            }
          }

          &.is-active {
            .el-radio-button__inner {
              background: #2b80c2;
              color: #fff;
            }
          }

          &.is-disabled {
            opacity: .3;
          }
        }
      }
    }

    .filtro__busca__focused {
      flex: 0.5 !important;

      .el-input__prefix {
        left: 5px !important;
        transform: translateX(0) !important;
      }

      .el-input--prefix {
        .el-input__inner {
          padding-left: 30px !important;
          padding-right: 15px !important;
        }
      }
    }

    .filtro__busca {
      flex: 0.01;
      transition: all 0.3s;
      margin: 15px 0 0 30px;

      .el-input {
        .el-input__inner {
          border-radius: 25px;
          background: #3a3a3a;
          color: #fff;
        }
      }
    }

    .el-input__prefix {
      left: 50% !important;
      top: 1px;
      transform: translateX(-50%) !important;
    }

    .el-input--prefix {
      .el-input__inner {
        padding: 22px !important;
      }
    }
  }

  @media (max-width: 768px) {
    margin: 0 0 25px 0;

    .filtro {
      flex-direction: column;
      align-items: normal;

      .filtro__item {
        font-size: 12px;

        .el-radio-group {
          margin-left: 0;

          .el-radio-button {
            .el-radio-button__inner {
              font-size: 11px;
            }
          }
        }
      }

      .filtro__busca {
        margin-left: 0;
      }
    }
  }
}
</style>